import { errorHandler } from "./error.service";
import { http, URL } from "./http.service";

export const createBooking  = async (businessUuid, bookingData) => {
  try { 
  const resp = await http.post(`${URL}/bookings/${businessUuid}`, bookingData);
  return resp.data;
  } catch (error) {
    errorHandler(error);
  } 
};

export const getSlots = async (businessUuid, serviceId, date, employeeId) => {
  try {
    const resp = await http.get(`${URL}/bookings/${businessUuid}/${serviceId}/slots`, {
      params: { date, employeeId },
    });
    return resp.data;
  } catch (error) {
    errorHandler(error);
    throw error;
  }
};

export const getBookings = async (businessUuid, filters = {}) => {
  try {
    const resp = await http.get(`${URL}/bookings/${businessUuid}`, {
      params: filters,
    });
    return resp.data;
  } catch (error) {
    errorHandler(error);
    throw error;
  }
};

export const updateBookingStatus = async (businessUuid, bookingId, status) => {
  try {
    const resp = await http.put(`${URL}/bookings/${businessUuid}/${bookingId}/status`, { status });
    return resp.data;
  } catch (error) {
    errorHandler(error);
    throw error;
  }
};

export const submitBookingReview = async (businessUuid, bookingId, reviewData) => {
  try {
    const resp = await http.post(`${URL}/bookings/${businessUuid}/${bookingId}/review`, reviewData);
    return resp.data;
  } catch (error) {
    errorHandler(error);
    throw error;
  }
};  

